import { render, staticRenderFns } from "./DeliverGoodsNum.vue?vue&type=template&id=2668f5fd&"
import script from "./DeliverGoodsNum.vue?vue&type=script&lang=js&"
export * from "./DeliverGoodsNum.vue?vue&type=script&lang=js&"
import style0 from "./DeliverGoodsNum.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports